import React, { useState, useEffect } from 'react';
import { Bot, MessageCircle, ExternalLink, Info } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function DigitalAssistantSection() {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const res = await fetch(`${API_URL}/api/mvp/admin/settings`);
      const data = await res.json();
      setSettings(data);
    } catch (err) {
      console.error('Failed to fetch settings:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading || !settings?.chatbot_enabled || !settings?.chatbot_url) {
    return null;
  }

  return (
    <div className="bg-gradient-to-r from-indigo-50 to-blue-50 rounded-2xl p-6 border border-indigo-100">
      {/* Header */}
      <div className="flex items-center gap-3 mb-4">
        <div className="p-2 bg-indigo-100 rounded-xl">
          <Bot className="text-indigo-600" size={24} />
        </div>
        <div>
          <h2 className="text-xl font-semibold text-gray-800">24×7 Digital Assistant</h2>
          <p className="text-sm text-gray-600">Always here to listen</p>
        </div>
      </div>

      {/* Description */}
      <p className="text-gray-600 mb-4">
        Our AI-powered assistant is available around the clock to provide emotional support,
        coping strategies, and helpful resources.
      </p>

      {/* Action Button */}
      <a
        href={settings.chatbot_url}
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center justify-center gap-2 w-full py-3 bg-gradient-to-r from-indigo-500 to-blue-500 text-white rounded-xl font-medium hover:from-indigo-600 hover:to-blue-600 transition-all shadow-md"
      >
        <MessageCircle size={20} />
        Talk to our digital assistant
        <ExternalLink size={16} />
      </a>

      {/* Disclaimer */}
      <div className="mt-4 flex items-start gap-2 text-xs text-gray-500">
        <Info size={14} className="flex-shrink-0 mt-0.5" />
        <p>
          This chatbot offers basic emotional support and self-help. For confidential care 
          with our counsellors, please use the MYC chat/voice options.
        </p>
      </div>
    </div>
  );
}
